/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    SET_FORMS(state, forms) {
        state.forms = forms
    },
    //SET_ROUNDTABLETOPICS(state, roundtabletopics) {
    //    state.roundtabletopics = roundtabletopics
    //},
    REMOVE_RECORD(state, formId) {
        const formIndex = state.forms.findIndex((u) => u.FormId === formId)
        state.forms.splice(formIndex, 1)
    }
}